// common/components/apexchart/defaultApexOptions.ts

import { Theme } from "@mui/material";
import ApexOptions from "../../../../../common/components/apexchart/ApexChartModels";

const defaultApexOptions = (theme: Theme): ApexOptions => ({
  chart: {
    stacked: false,
    width: "100%",
    fontFamily: "Inter",
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  markers: {
    size: 4,
  },
  theme: {
    mode: theme.palette.mode,
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  legend: {
    position: "top",
    horizontalAlign: "left",
    showForNullSeries: false,
    showForZeroSeries: false,
    showForSingleSeries: true,
    fontFamily: "Inter",
  },
  colors: [
    "#F150FF", // agg
    "#EB5564", // fire
    "#735EC9", // gasleak
    "#3E8DF3", // hardhat
    "#F3B344", // liquidLeak
    "#4EB100", // smoke
    "#67E09C", // tlm
  ],
  yaxis: {
    opposite: true,
  },
});

export default defaultApexOptions;
